import ProfileGradientHeader from './ProfileGradientHeader'

export default ProfileGradientHeader
